<template>
  <ValidationObserver ref="observer" tag="div">
    <v-form ref="form" @submit.prevent="validate">
      <slot>Empty form</slot>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { Types } from "@/store/modules/snackbar"

export default {
  name: "Form",
  props: {
    callback: { type: Function, required: true },
  },
  data: () => ({
    timeout: 0,
    errors: null,
  }),
  methods: {
    /** @public */
    async validate() {
      await this.$store.dispatch(Types.actions.HIDE)
      if (await this.$refs.observer.validate()) {
        this.callback()
          .then(() => {
            this.$emit("validated")
          })
          .catch(errors => {
            if (typeof errors !== "object") {
              let errorCode = errors.replace(/:.*/, "").trim()
              if (errorCode.charAt(0) === "E" && errorCode.length === 7) {
                let errorMessage = this.$t("form.errors." + errorCode)
                if (errorMessage === "form.errors." + errorCode) {
                  let mainErrorCode = errorCode.charAt(0) + errorCode.charAt(1) + errorCode.charAt(2) + "0000"
                  errorMessage = this.$t("form.errors." + mainErrorCode)
                  if (errorMessage !== "form.errors." + mainErrorCode) {
                    errors = errorMessage + " (" + errorCode + "," + errors + ")"
                  }
                } else {
                  errors = errorMessage
                }
              }
            } else if (typeof errors === "object" && errors.hasOwnProperty("code")) {
              errors[this.$t("form.errors.label")] = [this.$t("form.errors." + errors.code)]
              delete errors["code"]
              delete errors["message"]
            } else {
              for (const property in errors) {
                if (this.$t("form." + errors[property])) {
                  errors[property] = [this.$t("form." + errors[property])]
                }
                if (this.$t("form.fields." + property)) {
                  errors[this.$t("form.fields." + property)] = errors[property]
                  delete errors[property]
                }
              }
            }
            this.$store.dispatch(Types.actions.PUSH_MESSAGE, {
              lines: errors,
              config: { timeout: 1000 * 6, color: "error" },
            })
            this.$emit("error", errors)
          })
      }
    },
  },
}
</script>
